import { type Carrier } from './Carrier'
import { type Quote } from './Quote'
import { type Rate } from './Rate'
import { type Shipper } from './Shipper'
import { type SpotQuoteStatus } from './SpotQuoteStatus'

export type SpotQuote = {
  carrier: Carrier
  carrierNotes?: string
  notes?: string
  quote: Quote
  shipper: Shipper
  status: SpotQuoteStatus
  uuid: string
  negotiationNote?: string
  underNegotiation: boolean
} & Rate

export function canReceiveProposals(spotQuote?: SpotQuote) {
  return spotQuote?.quote.canReceiveProposals ?? true
}
